<div class="apple-admin-settings-card apple-card apple-fade-in">
  <div class="settings-header">
    <div class="settings-icon">
      <mat-icon>flash_on</mat-icon>
    </div>
    <div>
      <h2 class="apple-heading-3">Admin Werkzeuge</h2>
      <p class=" apple-body-secondary setting-text">
        Verwalte FAQs, Coin-Staffelungen und weitere Einstellungen.
      </p>
    </div>
  </div>

  <div class="settings-actions">
    <a mat-flat-button color="primary" [routerLink]="['/admin/search-customers']" class="apple-button apple-button-primary apple-button-large">
      <mat-icon>people</mat-icon>
      Kunden suchen
    </a>
    <a mat-flat-button color="primary" [routerLink]="['/admin/sales-users/manage']" class="apple-button apple-button-primary apple-button-large">
      <mat-icon>badge</mat-icon>
      Vertriebler verwalten
    </a>
    <a mat-flat-button color="primary" [routerLink]="['/admin/manage-faqs']" class="apple-button apple-button-primary apple-button-large">
      <mat-icon>help_center</mat-icon>
      FAQs verwalten
    </a>
    <a mat-flat-button color="primary" [routerLink]="['/admin/coins/manage']" class="apple-button apple-button-primary apple-button-large">
      <mat-icon>paid</mat-icon>
      Coin-Staffelung
    </a>
    <a mat-flat-button color="primary" [routerLink]="['/admin/customers/manage']" class="apple-button apple-button-primary apple-button-large">
      <mat-icon>paid</mat-icon>
      Kundenzugriffe verwalten
    </a>
    <a mat-flat-button color="primary" [routerLink]="['/admin/feedback']" class="apple-button apple-button-primary apple-button-large">
      <mat-icon>paid</mat-icon>
      Feedback Übersicht
    </a>
  </div>
</div>
